import { TUserRole, UserRole } from "../transports/user";
export type TPrivateRouteMap = {
    url: string;
    requiredRole: "ALL" | TUserRole[] | undefined;
    title?: string;
}[];

export const privateRouteMap: TPrivateRouteMap = [
    //All access
    { url: "user/profile", title: "layout.profile.profile", requiredRole: "ALL" },
    { url: "/dashboard", title: "MENU.DASHBOARD", requiredRole: "ALL" },
    {
        url: "/resource",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_WEBMASTER,
            UserRole.ROLE_LEAD_WEBMASTER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "library",
        title: "library.title",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    { url: "activity", title: "layout.log.title", requiredRole: "ALL" },

    //message-center
    {
        url: "/message-center",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
        ],
    },
    {
        url: "/message-center/*",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
        ],
    },
    {
        url: "/message-center/unProcess",
        title: "messagerCenter.manage.all.unprocess",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
        ],
    },
    {
        url: "/message-center/inProcess",
        title: "messagerCenter.manage.sell.inProcess",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
        ],
    },
    {
        url: "/message-center/paid",
        title: "messagerCenter.manage.sell.paid",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
        ],
    },
    {
        url: "/message-center/spam",
        title: "messagerCenter.manage.all.spam",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
        ],
    },
    {
        url: "/message-center/published",
        title: "messagerCenter.manage.sell.published",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
        ],
    },

    { url: "auth", title: "Auth", requiredRole: "ALL" },
    //site Area
    {
        url: "sites/seo",
        title: "site.manage.sites.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_WEBMASTER,
            UserRole.ROLE_LEAD_WEBMASTER,
        ],
    },

    {
        url: "/sites/*",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_WEBMASTER,
            UserRole.ROLE_LEAD_WEBMASTER,
        ],
    },
    {
        url: "/sites",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_WEBMASTER,
            UserRole.ROLE_LEAD_WEBMASTER,
        ],
    },
    {
        url: "sites/infra",
        title: "site.manage.infra.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_WEBMASTER,
            UserRole.ROLE_LEAD_WEBMASTER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
        ],
    },
    { url: "sites/pbns", title: "site.manage.pbns.link", requiredRole: [UserRole.ROLE_ADMIN] },
    {
        url: "sites/registrars",
        title: "site.manage.registrars.link",
        requiredRole: [UserRole.ROLE_ADMIN],
    },
    //Directory
    {
        url: "/directory/management",
        title: "directory.manage.sites.link",
        requiredRole: [UserRole.ROLE_ADMIN, UserRole.ROLE_LEAD_LINKER, UserRole.ROLE_LINKER],
    },
    {
        url: "/directory/*",
        requiredRole: [UserRole.ROLE_ADMIN, UserRole.ROLE_LEAD_LINKER, UserRole.ROLE_LINKER],
    },
    {
        url: "/directory",
        requiredRole: [UserRole.ROLE_ADMIN, UserRole.ROLE_LEAD_LINKER, UserRole.ROLE_LINKER],
    },
    //Platforms Area
    {
        url: "platforms/*",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
        ],
    },
    {
        url: "/platforms",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
        ],
    },
    {
        url: "/platforms/management",
        title: "platform.manage.platforms.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
        ],
    },
    {
        url: "/platforms/agency",
        title: "platform.manage.agency.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
        ],
    },
    {
        url: "/platforms/direct",
        title: "platform.manage.direct.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
        ],
    },
    //Content Area
    {
        url: "/content",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROOFREADER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_WRITER,
            UserRole.ROLE_LEAD_LINKER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_PROOFREADER,
            UserRole.ROLE_WRITER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
        ],
    },
    {
        url: "/content/stock/*",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_WRITER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
        ],
    },
    {
        url: "/content/stock",
        title: "stock.title",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_WRITER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
        ],
    },
    {
        url: "/content/toWrite",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_WRITER,
            UserRole.ROLE_LEAD_WRITER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/toWrite/*",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_WRITER,
            UserRole.ROLE_LEAD_WRITER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/toWrite/all",
        title: "writer.manage.all.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_WRITER,
            UserRole.ROLE_LEAD_WRITER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/toWrite/delivered",
        title: "writer.manage.delivered.link",
        requiredRole: [UserRole.ROLE_ADMIN],
    },
    {
        url: "/content/delivered",
        title: "delivered.title",
        requiredRole: [UserRole.ROLE_LEAD_WRITER, UserRole.ROLE_WRITER],
    },
    {
        url: "/content/toProofread",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_PROOFREADER,
            UserRole.ROLE_LEAD_PROOFREADER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
            UserRole.ROLE_LEAD_LINKER,
            UserRole.ROLE_LINKER,
        ],
    },
    {
        url: "/content/toProofread/reviewed/blog",
        title: "reviewed.manage.reviewed.blog",
        requiredRole: [UserRole.ROLE_ADMIN],
    },
    {
        url: "/content/toProofread/reviewed/lp",
        title: "reviewed.manage.reviewed.lp",
        requiredRole: [UserRole.ROLE_ADMIN],
    },
    {
        url: "/content/toProofread/images",
        title: "reviewed.manage.images",
        requiredRole: [UserRole.ROLE_ADMIN],
    },
    {
        url: "/content/reviewed",
        requiredRole: [UserRole.ROLE_LEAD_PROOFREADER, UserRole.ROLE_PROOFREADER],
    },
    {
        url: "/content/reviewed/*",
        requiredRole: [UserRole.ROLE_LEAD_PROOFREADER, UserRole.ROLE_PROOFREADER],
    },
    {
        url: "/content/reviewed/reviewed/blog",

        title: "reviewed.manage.reviewed.blog",
        requiredRole: [UserRole.ROLE_LEAD_PROOFREADER, UserRole.ROLE_PROOFREADER],
    },
    {
        url: "/content/reviewed/reviewed/lp",
        title: "reviewed.manage.reviewed.lp",
        requiredRole: [UserRole.ROLE_LEAD_PROOFREADER, UserRole.ROLE_PROOFREADER],
    },
    {
        url: "/content/reviewed/images",
        title: "reviewed.manage.images",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROOFREADER,
            UserRole.ROLE_PROOFREADER,
        ],
    },
    {
        url: "/content/toProcess",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/toApprove",
        title: "approve.title",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROOFREADER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/toPublish",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/toPublish/blog",
        title: "toPublish.manage.blog.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/toPublish/lp",
        title: "toPublish.manage.lp.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/waiting",
        title: "waiting.title",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/online",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_PROOFREADER,
            UserRole.ROLE_LEAD_WRITER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/online/*",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_PROOFREADER,
            UserRole.ROLE_LEAD_WRITER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/online/all",
        title: "online.manage.all.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_PROOFREADER,
            UserRole.ROLE_LEAD_WRITER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/online/sell",
        title: "online.manage.sell.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_PROOFREADER,
            UserRole.ROLE_LEAD_WRITER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    {
        url: "/content/online/network",
        title: "online.manage.network.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LINKER,
            UserRole.ROLE_LEAD_PROOFREADER,
            UserRole.ROLE_LEAD_WRITER,
            UserRole.ROLE_LEAD_LINKER,
        ],
    },
    //Analyse Area
    {
        url: "/analyse",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
        ],
    },
    {
        url: "/analyse/boost",
        title: "boost.title",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/global",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/global/traffic",
        title: "siteAnalyze.manage.traffic",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/global/monitoring",
        title: "siteAnalyze.manage.monitoring",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/global/filling",
        title: "siteAnalyze.manage.filling",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/seoMetrics",
        title: "siteAnalyze.manage.seoMetrics",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/content",
        title: "siteAnalyze.manage.contents",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },

    {
        url: "/analyse/zoom/offSite",
        title: "siteAnalyze.manage.offSite",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/*",
        title: "siteAnalyze.manage.offSite",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/lp",
        title: "siteAnalyze.manage.LP",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/nl",
        title: "siteAnalyze.manage.NL",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/rank",
        title: "siteAnalyze.manage.RANK",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/filling",
        title: "siteAnalyze.manage.FILLING",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/disc",
        title: "siteAnalyze.manage.DISC",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/sell",
        title: "siteAnalyze.manage.SELL",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/affi",
        title: "siteAnalyze.manage.AFFI",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/boost",
        title: "siteAnalyze.manage.BOOST",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/lead",
        title: "siteAnalyze.manage.LEAD",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/silo",
        title: "siteAnalyze.manage.silo",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/history",
        title: "siteAnalyze.manage.history",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/offSite/planned",
        title: "siteAnalyze.manage.LEAD",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite",
        title: "siteAnalyze.manage.onSite",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },

    {
        url: "/analyse/zoom/onSite/*",
        title: "siteAnalyze.manage.offSite",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite/lp",
        title: "siteAnalyze.manage.LP",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite/nl",
        title: "siteAnalyze.manage.NL",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite/rank",
        title: "siteAnalyze.manage.RANK",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite/filling",
        title: "siteAnalyze.manage.FILLING",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite/disc",
        title: "siteAnalyze.manage.DISC",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite/sell",
        title: "siteAnalyze.manage.SELL",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite/affi",
        title: "siteAnalyze.manage.AFFI",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite/boost",
        title: "siteAnalyze.manage.BOOST",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite/lead",
        title: "siteAnalyze.manage.LEAD",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite/silo",
        title: "siteAnalyze.manage.silo",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/onSite/history",
        title: "siteAnalyze.manage.history",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/seoMetrics",
        title: "siteAnalyse.manage.seoMetrics",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/zoom/content",
        title: "siteAnalyse.manage.contents",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/urls",
        title: "urlsAnalyzed.manage.title",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/urls/*",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/keywords",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
        ],
    },

    {
        url: "/analyse/keywords/verified",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/keywords/verified/*",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/keywords/verified/ranklvl1",
        title: "keyword.manage.ranklvl1.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/keywords/verified/ranklvl2",
        title: "keyword.manage.ranklvl2.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/keywords/verified/ranklvl3",
        title: "keyword.manage.ranklvl3.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },
    {
        url: "/analyse/keywords/verified/aiAuto",
        title: "keyword.manage.aiAuto.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
        ],
    },

    {
        url: "/analyse/keywords/toVerify",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
        ],
    },
    {
        url: "/analyse/keywords/toVerify/*",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
        ],
    },
    {
        url: "/analyse/keywords/toVerify/ranklvl1",
        title: "keyword.manage.ranklvl1.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
        ],
    },
    {
        url: "/analyse/keywords/toVerify/ranklvl2",
        title: "keyword.manage.ranklvl2.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
        ],
    },
    {
        url: "/analyse/keywords/toVerify/ranklvl3",
        title: "keyword.manage.ranklvl3.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
        ],
    },
    {
        url: "/analyse/keywords/toVerify/aiAuto",
        title: "keyword.manage.aiAuto.link",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_WORKER,
            UserRole.ROLE_WORKER,
        ],
    },
    //Reports Area
    {
        url: "/reports",
        requiredRole: [
            UserRole.ROLE_ADMIN,
            UserRole.ROLE_LEAD_BUSINESS_MANAGER,
            UserRole.ROLE_LEAD_PROOFREADER,
            UserRole.ROLE_LEAD_PROJECT_MANAGER,
            UserRole.ROLE_LEAD_LINKER,
            UserRole.ROLE_LEAD_WRITER,
        ],
    },
    {
        url: "/reports/writers",
        title: "MENU.reportWriter",
        requiredRole: [UserRole.ROLE_ADMIN, UserRole.ROLE_LEAD_WRITER],
    },
    {
        url: "/reports/proofreaders",
        title: "MENU.reportProofreader",
        requiredRole: [UserRole.ROLE_ADMIN, UserRole.ROLE_LEAD_PROOFREADER],
    },
    //Only Admin
    {
        url: "space-management/*",
        requiredRole: [UserRole.ROLE_ADMIN],
    },
    { url: "stats/*", title: "stats.management.title", requiredRole: [UserRole.ROLE_ADMIN] },
    { url: "/stats", title: "stats.management.title", requiredRole: [UserRole.ROLE_ADMIN] },
    {
        url: "budgets/*",
        requiredRole: [UserRole.ROLE_ADMIN],
    },
    {
        url: "/budgets/earnings/platform",
        title: "budget.manage.earningsPlatform.link",
        requiredRole: [UserRole.ROLE_ADMIN],
    },
    {
        url: "/budgets/earnings/turnover",
        title: "budget.manage.earningsTurnover.link",
        requiredRole: [UserRole.ROLE_ADMIN],
    },
    {
        url: "/budgets/expenses",
        title: "budget.manage.expenses.link",
        requiredRole: [UserRole.ROLE_ADMIN],
    },
    {
        url: "/budgets",
        requiredRole: [UserRole.ROLE_ADMIN],
    },
];

export function checkPathRequirement(path: string, userRole: TUserRole | undefined) {
    const mainPath = `${path.split("/")[0]}/*`;
    return privateRouteMap.some(
        (el) =>
            (el.url == path || el.url == mainPath) &&
            userRole != undefined &&
            (el.requiredRole?.includes(userRole) || el.requiredRole == "ALL")
    );
}
export function getRequiredRoleByPath(path: string): Array<TUserRole> | "ALL" | "" {
    const element = privateRouteMap.find((el) => el.url == path);
    const roles = element?.requiredRole || "";
    return roles;
}

export function getPageTitle(path: string) {
    const element = privateRouteMap.find((el) => el.url === path);
    return element?.title;
}

export default privateRouteMap;
